import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Loader from '../Components/Loader';
import img1 from '../assets/Events/SunderKaand_Paath/1.jpeg';
import img2 from '../assets/Events/SunderKaand_Paath/2.jpeg';
import img3 from '../assets/Events/SunderKaand_Paath/3.jpeg';
import img4 from '../assets/Events/SunderKaand_Paath/4.jpeg';
import img5 from '../assets/Events/SunderKaand_Paath/5.jpeg';
import img6 from '../assets/Events/SunderKaand_Paath/6.jpeg';
import img7 from '../assets/Events/SunderKaand_Paath/7.jpeg';
import img8 from '../assets/Events/SunderKaand_Paath/8.jpeg';
import demo from '../assets/Events/SunderKaand_Paath/demo.mp4';
import aarti_video from '../assets/Events/SunderKaand_Paath/aarti.mp4';
import aarti_thumbnail from '../assets/carousel/shri_hanuman_ji.jpg';

const GalleryPage = () => {
  const sections = [
    {
      name: 'SunderKaand Paath, MahaAarti, and Mahaprasad',
      images: [
        {
          image: img1,
          name: 'Sacred MahaAarti',
          description:
            'Devotees participating in the divine MahaAarti ceremony.',
          type: 'image',
        },
        {
          image: img2,
          name: 'Sacred MahaAarti',
          description: 'A beautiful moment of the sacred MahaAarti ritual.',
          type: 'image',
        },
        {
          video: aarti_video,
          thumbnail: aarti_thumbnail,
          name: 'MahaAarti Video',
          description: 'A glimpse of the MahaAarti ceremony.',
          type: 'video',
        },
        {
          image: img3,
          name: 'Sacred MahaAarti',
          description:
            'An atmosphere filled with devotion during the MahaAarti.',
          type: 'image',
        },
        {
          image: img4,
          name: 'Mahaprasad Ceremony',
          description: 'Offering and distribution of Mahaprasad to devotees.',
          type: 'image',
        },
        {
          image: img5,
          name: 'Mahaprasad Ceremony',
          description: 'Devotees receiving the blessings of Mahaprasad.',
          type: 'image',
        },
        {
          image: img6,
          name: 'Sacred MahaAarti',
          description: 'A serene moment from the MahaAarti ceremony.',
          type: 'image',
        },
        {
          image: img7,
          name: 'Mahaprasad Celebration',
          description: 'Devotees enjoying the sacred offering of Mahaprasad.',
          type: 'image',
        },
        {
          image: img8,
          name: 'Mahaprasad Celebration',
          description:
            'A moment of togetherness during the Mahaprasad offering.',
          type: 'image',
        },
      ],
    },
  ];

  const [viewMore, setViewMore] = useState(false);
  const [loadingStates, setLoadingStates] = useState({});
  const visibleSections =
    viewMore || window.innerWidth >= 768 ? sections : [sections[0]];
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const section = document.querySelector(location.hash);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  const handleImageLoad = (index) => {
    setLoadingStates((prevState) => ({ ...prevState, [index]: false }));
  };

  const handleImageLoadStart = (index) => {
    setLoadingStates((prevState) => ({ ...prevState, [index]: true }));
  };

  return (
    <div className="p-4">
      {visibleSections.map((section, sectionIndex) => (
        <div
          id={`section${sectionIndex + 1}`}
          key={sectionIndex}
          className="mb-8"
        >
          <h2 className="text-[30px] md:text-[40px] mt-[20px] ml-4 font-abhaya mb-2 text-[#800000] text-left">
            {section.name}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {section.images.map((obj, index) => {
              const uniqueKey = `${sectionIndex}-${index}`;
              return (
                <div
                  key={uniqueKey}
                  className="relative group overflow-hidden rounded-lg shadow-lg aspect-square"
                >
                  {obj.type === 'image' ? (
                    <>
                      {loadingStates[uniqueKey] && (
                        <div className="absolute inset-0 flex justify-center items-center bg-white bg-opacity-75 z-10">
                          <Loader />
                        </div>
                      )}
                      <img
                        src={obj.image}
                        alt={obj.name}
                        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                        onLoad={() => handleImageLoad(uniqueKey)}
                        onLoadStart={() => handleImageLoadStart(uniqueKey)}
                      />
                    </>
                  ) : obj.type === 'video' ? (
                    <div className="relative w-full h-full group">
                      <video
                        controls
                        className="w-full h-full object-cover"
                        preload="metadata"
                        poster={obj.thumbnail}
                      >
                        <source src={obj.video} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                      <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100 pointer-events-none">
                        <div className="bg-black bg-opacity-50 rounded-full p-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-10 h-10 text-white"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M8 5v14l11-7z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <div className="absolute inset-0 bg-[#9B2912] bg-opacity-70 flex flex-col justify-center items-center opacity-0 transition-opacity duration-300 group-hover:opacity-100 pointer-events-none">
                    <h3 className="text-white text-lg font-bold mb-2">
                      {obj.name}
                    </h3>
                    <p className="text-white text-sm px-4 text-center">
                      {obj.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
      <div className="mt-4 text-center md:hidden">
        <button
          onClick={() => setViewMore(!viewMore)}
          className="px-4 py-2 bg-gradient-to-r from-[#E66526] to-[#BE3D23] text-white rounded-md focus:outline-none focus:ring"
        >
          {viewMore ? 'View Less' : 'View More'}
        </button>
      </div>
    </div>
  );
};

export default GalleryPage;
